var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "avatar-container" }, [
    _c(
      "div",
      { staticClass: "avatar", class: [{ "avatar_has-border": !_vm.vip }] },
      [
        _c("div", {
          staticClass: "avatar__picture",
          style: {
            backgroundImage:
              "url(" +
              (_vm.src
                ? _vm.$imgfilter(_vm.src)
                : require("@/assets/images/logo_main_m.png")) +
              ")",
          },
        }),
      ]
    ),
    _vm.vip
      ? _c("div", {
          staticClass: "avatar__border",
          style: {
            backgroundImage:
              "url(" +
              require("@/assets/images/icon/vip/" + _vm.vip + ".png") +
              ")",
          },
        })
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }